import { GrufBus } from "../GrufBus";
import { Reverb, ToneAudioNode } from "tone";

export class ReverbReturn extends ToneAudioNode {
    static parametersDescription = {
        ...GrufBus.parametersDescription,
        wet: { type: 'float', min: 0, max: 1, initial: 1 },
        decay: {type: 'enum', options: ['1.0', '5.0', '12.0'], initial: '1.0'},
    }

    constructor() {
        super();
        this.reverb = new Reverb();
        this.bus = new GrufBus();
        this.reverb.connect(this.bus);
        this.input = this.reverb;
        this.output = this.bus;
    }

    dispose() {
        this.reverb.dispose();
        this.bus.dispose();
    }

    set gain(value) {
        this.bus.gain = value;
    }

    set wet(value) {
        this.reverb.wet.value = value;
    }

    set decay(value) {
        this.reverb.decay = value;
    }

    getCurrentLevel() {
        return Math.max(...this.bus.getCurrentLevels());
    }

}